import { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { AISidebarProvider } from './ai/AISidebarContext';
import { PluginProvider } from './core/PluginContext';
import { AppRouter } from './core/router';
import { useGlobalStore } from './core/store';
import http from './core/http';

// 判断是否需要显示后台布局的路由
const PUBLIC_ROUTES = ['/', '/login'];

function AppContent() {
  const location = useLocation();
  const { isAuthenticated, token, setUser, logout } = useGlobalStore();
  const isPublicRoute = PUBLIC_ROUTES.includes(location.pathname);
  const showLayout = !isPublicRoute && isAuthenticated;

  // 应用启动时验证 token
  useEffect(() => {
    const validateToken = async () => {
      if (token && !isAuthenticated) {
        // 如果有 token 但没有用户信息，尝试获取用户信息
        try {
          const response = await http.get<{
            code: number;
            data: {
              id: number;
              username: string;
              email: string;
              role: string;
            };
          }>('/users/me');
          
          if (response.data.code === 0 && response.data.data) {
            setUser({
              id: response.data.data.id,
              username: response.data.data.username,
              email: response.data.data.email,
              role: response.data.data.role as any,
            });
          } else {
            logout();
          }
        } catch (error) {
          // Token 无效，清除认证状态
          logout();
        }
      } else if (token && isAuthenticated) {
        // 如果有 token 和用户信息，验证 token 是否仍然有效
        // 这里可以添加定期验证逻辑
      }
    };

    validateToken();
  }, [token, isAuthenticated, setUser, logout]);

  return (
    <PluginProvider>
      <AISidebarProvider>
        {showLayout ? (
          <Layout>
            <AppRouter />
          </Layout>
        ) : (
          <AppRouter />
        )}
      </AISidebarProvider>
    </PluginProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;

